import { HashRouter } from "react-router-dom";
import { GeneralRoutes } from "./routes/GeneralRoutes";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/config";
import AuthProvider from "./contexts/auth.context";
import NotificationProvider from "./contexts/notification.context";
import PaymentProvider from "./contexts/payment.context";
import PathnameProvider from "./contexts/pathname.context";

function App() {
    return (
        <HashRouter>
            <I18nextProvider i18n={i18n}>
                <NotificationProvider>
                    <PathnameProvider>
                        <AuthProvider>
                            <PaymentProvider>
                                <GeneralRoutes></GeneralRoutes>
                            </PaymentProvider>
                        </AuthProvider>
                    </PathnameProvider>
                </NotificationProvider>
            </I18nextProvider>
        </HashRouter>
    );
}

export default App;
